import { render, staticRenderFns } from "./my-select.vue?vue&type=template&id=145d1412&"
import script from "./my-select.vue?vue&type=script&lang=js&"
export * from "./my-select.vue?vue&type=script&lang=js&"
import style0 from "./my-select.vue?vue&type=style&index=0&id=145d1412&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports